import { FromJSONable } from "../../model/FromJSONable";

export interface ZipCodeResponse {
  id: number;
  codigo: string;
  estado: Estado;
  estadoCodigo: string;
  municipio: Localidad;
  municipioCodigo: string;
  localidad: Localidad;
  localidadCodigo: string;
  mensaje: null;
  Exception: null;
}
export interface Estado {
  id: number;
  codigo: string;
  descripcion: string;
  pais: Pais;
  paiCodigo: string;
}

export interface Pais {
  id: number;
  codigo: string;
  descripcion: string;
}

export interface Localidad {
  id: number;
  codigo: string;
  descripcion: string;
  estado: Estado;
  estCodigo: string;
}
export interface SuburbResponse {
  id: number;
  codigo: string;
  descripcion: string;
  cp: string;
  mensaje: null;
  Exception: null;
}
export class ZipCodeClass implements ZipCodeResponse, FromJSONable {
  constructor() {}
  parseJSONObject(object: Object) {
    Object.assign(this, object);
  }
  id: number;
  codigo: string;
  estado: Estado;
  estadoCodigo: string;
  municipio: Localidad;
  municipioCodigo: string;
  localidad: Localidad;
  localidadCodigo: string;
  mensaje: null;
  Exception: null;
}
export class SuburbClass implements FromJSONable {
  constructor() {}
  suburbs: SuburbResponse[] = [];
  parseJSONObject(object: Object) {
    Object.assign(this.suburbs, object);
  }
}
